import { render, staticRenderFns } from "./AssistantUpsertForm.vue?vue&type=template&id=714c8265"
import script from "./AssistantUpsertForm.vue?vue&type=script&lang=js"
export * from "./AssistantUpsertForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports